module.exports = __webpack_public_path__ + "fonts/euclid-square-700.50edc217.ttf";